import React from "react";

export default function NotAuthorized() {
  return (
    <div style={{ padding: "40px", fontFamily: "Arial" }}>
      <h1>Access Denied</h1>
      <p>You do not have permission to access this page.</p>

      <div
        style={{
          marginTop: "20px",
          padding: "20px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          background: "#fef2f2",
          color: "#b91c1c"
        }}
      >
        <strong>Only CloudGenomics internal administrators</strong> are allowed to
        access the Super Admin Portal.
      </div>
    </div>
  );
}